<p *ngIf="visible" [innerHTML]="content" class="card-text form-info my-2"></p>
